<template>
	<div>
		<button v-if="user_meta_actions.includes('add_provider_to_a_program')" type="button" class="button" @click="show_add = !show_add">
			<slot name="text-button"></slot>
		</button>

		<b-modal v-model="show_add" title="Add employee to program" ok-title="Add to program" 
    @close="resetModal" @ok.prevent="addToCourse" size="xl">

			<p class="mb-2">

				<div class="row mb-2">
					<div class="col">
						<template v-if="organization.id != '_'">
							<div><strong>Agency:</strong> {{ organization.name }}</div>
						</template>

						<div><strong>First name:</strong> {{ provider.first_name }}</div>
						<div><strong>Last name:</strong> {{ provider.last_name }}</div>
						<div><strong>Cell phone number:</strong> {{ provider.country_code }} {{ provider.phone }}</div>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<div class="input-content">
							<label class="mb-1">Program*</label>
							<v-select :options="courses" :show-labels="true" class="green green-dark bg-gray v-select-no-height" multiple v-model="selected_course" label="label" v-validate="'required'" name="course"></v-select>
							<span class="input-error-msg"  v-if="errors.first('course')">Program is mandatory</span>
						</div>
          </div>
        </div>
        <div class="row">
					<div class="col">
						<div class="form-group input-content">
							<label>Program start date by*</label>
							<v-select class="mb-2"  :searchable="false"  name="starting_date_method_"
									v-validate="'required'"
									:options="program_start_date_options" v-model="form.starting_date_method_">
							</v-select>
							<span class="input-error-msg" v-if="errors.first('starting_date_method_')">Timing selection is mandatory</span>
						</div>
        
            <br>

            <div class="form-group input-content">
							<label>Program due date by*</label>
							<v-select class="mb-2"  :searchable="false"  name="timing_method_"
									v-validate="'required'"
									:options="program_due_date_options" v-model="form.timing_method_">
							</v-select>
							<span class="input-error-msg" v-if="errors.first('timing_method_')">Timing selection is mandatory</span>
						</div>
						
						<h6  style="color: rgb(219, 80, 74); text-align: center;" v-show="!organization.is_active || provider.provider_status_id == 2">
            This Employee is ON HOLD - they will only get access to the training once they are active.</h6>
					</div>
          <div class="col">
            <div v-if="custom_start_date_chosen" class="form-group input-content">
							<label>Start date*</label>
							<datetime placeholder="Start date*" type="date"  v-validate="'required'" name="start_date"
								v-model="form.start_date" ></datetime>

							<span class="input-error-msg" v-if="errors.first('start_date')">Due date is mandatory</span>
						</div>
            <div v-if="custom_start_plus_days" class="form-group input-content">
							<label>Plus days (optional)</label>
							<input placeholder="Set a number" name="starting_date_plus_x_days" value=0 type="number" min="0" 
								v-model="form.starting_date_plus_x_days" />

							<span class="input-error-msg"  v-if="errors.first('starting_date_plus_x_days')">Number of days is mandatory</span>
						</div>

            <br>

            <div v-if="custom_due_date_chosen" class="form-group input-content">
							<label>Due date*</label>
							<datetime placeholder="Due date*" type="date"  v-validate="'required'" name="due_date"
								v-model="form.due_date" ></datetime>

							<span class="input-error-msg" v-if="errors.first('due_date')">Due date is mandatory</span>
						</div>
						<div v-if="custom_due_plus_days" class="form-group input-content">
							<label>Plus days (optional)</label>
							<input placeholder="Set a number" name="duration_days_from_start_date" value=0 type="number" min="0"
								v-model="form.duration_days_from_start_date" />

							<span class="input-error-msg"  v-if="errors.first('duration_days_from_start_date')">Number of days is mandatory</span>
						</div>

          </div>
				</div>				
			</p>
		</b-modal>
	</div>
</template>

<script>
import moment from 'moment'

export default {
  
  props: {
    provider: {
      type: Object,
      required: true
    },
    organization: {
      type: Object,
      required: false
    }
  },

  data: function() {
    return {
      show_add: false,
      courses: [],
      selected_course: null,
      form: {
        start_date: null,
        due_date: null,
        starting_date_method_: null,
        timing_method_: null,
        starting_date_plus_x_days_: null,
        duration_days_from_start_date_: null
      },
      program_start_date_options: [
        { value: 2, label: "Today" },
        { value: 2, label: "Custom Date" },
        { value: 3, label: "Anniversary Date" },
        { value: 4, label: "Anniversary Month" }
      ],
      user_meta_actions: localStorage.getItem("meta_actions"),
      program_due_date_options: [
        { value: 1, label: "December 31st" },
        { value: 4, label: "Custom Date" },
        { value: 5, label: "Number of Days from Start Date" },
        { value: 2, label: "One year from Start Date" }
      ],
      user_meta_actions: localStorage.getItem("meta_actions")
    };
  },
  computed: {
    custom_start_date_chosen: function() {
      if (this.form.starting_date_method_) {
        if (this.form.starting_date_method_.value == 2) {
          if (this.form.starting_date_method_.label == 'Today') {
            this.form.start_date = moment(new Date()).format('YYYY-MM-DD');
          }
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    custom_start_plus_days: function() {
      if (this.form.starting_date_method_) {
        if (this.form.starting_date_method_.value == 3 || this.form.starting_date_method_.value == 4) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    custom_due_date_chosen: function() {
      if (this.form.timing_method_) {
        if (this.form.timing_method_.value == 4) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    custom_due_plus_days: function() {
      if (this.form.timing_method_) {
        if (this.form.timing_method_.value == 5) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },

  created: function() {
    this.getCourses();
  },

  methods: {
    resetModal: function() {
      this.selected_course = null;
      this.form.start_date = null;
      this.form.starting_date_method_ = null;
      this.form.timing_method_ = null;
      this.form.due_date = null;
      this.starting_date_plus_x_days_ = null;
      this.duration_days_from_start_date_ = null;
    },

    getCourses: function() {
      var params = {
        filters: {
          to_select: true,
          in_organization: this.organization.id,
          only_organization: true,
          published: true
        }
      };

      this.$store
        .dispatch("getCourses", params)
        .then(response => {
          this.courses = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    addToCourse: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          var params = {
            provider_id: this.provider.id,
            organization_id: this.organization.id,
            filters: {
              organization_id: this.organization.id,
              course_ids: this.selected_course.map(elem => elem.value),
              starting_date: null,
              due_date: null,
              timing_method: this.form.timing_method_.value,
              starting_date_method: this.form.starting_date_method_.value,
              starting_date_plus_x_days: null,
              duration_days_from_start_date: null,
            }
          };
          if (params.filters.starting_date_method == 2) {
            params.filters.starting_date = moment(this.form.start_date).format('YYYY-MM-DD');
          }
          if (params.filters.timing_method == 4) {
            params.filters.due_date = moment(this.form.due_date).format('YYYY-MM-DD');
          }
          if (params.filters.starting_date_method == 3 || params.filters.starting_date_method == 4) {
            params.filters.starting_date_plus_x_days = this.form.starting_date_plus_x_days;
            console.log("Aca Imprime Start");
            console.log(this.form.starting_date_plus_x_days);
          }
          if (params.filters.timing_method == 5) {
            params.filters.duration_days_from_start_date = this.form.duration_days_from_start_date;
            console.log("Aca Imprime Due");
            console.log(this.form.duration_days_from_start_date);
          }
          this.show_add = false;
          this.resetModal();

          this.$store
            .dispatch("addProviderToCourses", params)
            .then(res => {
              this.$emit("providerAdded");
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/AddProviderToCourseComponent.vue